import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from '../constants';
import { PayInResource } from './types';

export type Response = PayInResource;

export default (makeCall: MakeCall) =>
  (uuid: string, settlementReference: string) =>
    makeCall<Response>('PUT', `${APIV2_URL}/payment/pay-in/${uuid}/confirm`, {
      data: { settlementReference },
    });
